import React from "react";

import NotificationPortalModal from "@components/NotificationPortalModal";

import useNotificationPortalInternal from "../hook/useNotificationPortalInternal";
import { NotificationPortalContext } from "../hook/useNotificationPortal";

const NotificationPortalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const portal = useNotificationPortalInternal();

  const {
    state: { open, currentNotification, hasNext },
    action: { handleClose, handleNext, handleUnread },
  } = portal;

  return (
    <NotificationPortalContext.Provider value={portal}>
      {children}

      <NotificationPortalModal
        open={open}
        notificationUser={currentNotification || null}
        hasNext={hasNext}
        onClose={handleClose}
        onNext={handleNext}
        onUnread={handleUnread}
      />
    </NotificationPortalContext.Provider>
  );
};

export default NotificationPortalProvider;
